const informationContent = [
  {
    heading: 'Information You Give Us',
    paragraphs: [
      'We receive and store any information you enter on our Web site or give us in any other way. You can choose not to provide certain information, but then you might not be able to take advantage of many of our features. We use the information that you provide for such purposes as responding to your requests, customizing future showings for you and communicate with you.',
    ],
  },
  {
    heading: 'Automatic Information',
    paragraphs: [
      'We receive and store certain types of information whenever you interact with us. For example, like many Web sites, we use "cookies," and we obtain certain types of information when your Web browser accesses EntrepreneurSeminar.com or advertisements and other content served by or on behalf of Entrepreneur Insight Ltd on other Web sites. See our Cookie Policy below for more details and how to disable cookies if you wish.',
    ],
  },
  {
    heading: 'Mobile',
    paragraphs: [
      'When you download or use apps created by Entrepreneur Seminar or our subsidiaries, we may receive information about your location and your mobile device, including a unique identifier for your device. We may use this information to provide you with location-based services, such as advertising, search results, and other personalized content. Most mobile devices allow you to turn off location services.',
    ],
  },
  {
    heading: 'E-mail Communications',
    paragraphs: [
      'We will only send you marketing emails if you give us express permission to do so. You can give us permission to send you an email  on the form where you register your account. You can unsubscribe from any of our marketing emails by clicking the “unsubscribe” link at the bottom of the email we send. Regardless of your marketing preferences we may still send you transactional emails, such as confirmation emails and invoices for payments. To help us make emails more useful and interesting, we often receive a confirmation when you open an email from Entrepreneur Seminar and when you click on the links in the email if your device supports such capabilities.',
    ],
  },
  {
    heading: 'Information from Other Sources',
    paragraphs: [
      'Apart from the information set out above, we do not store any personal information you have not explicitly provided to us.',
    ],
  },
]

export default informationContent
